import React, { Component } from 'react'

import { URIS } from '../../Uris'

class MissionChoicer extends Component {
  prepareMissions () {
    const holes = this.props.missions.holes
    const nm = Math.ceil(holes.length / 25)
    const m = []
    for (let i = 0; i < nm; i++) {
      m.push(holes.slice((i * 25), (i + 1) * 25))
    }
    return m
  }

  parseHoles (m) {
    let r = ''
    m.forEach(h => {
      if (r !== '') {
        r += '|'
      }
      r += h.lat + ',' + h.lng
    })
    return r
  }

  render () {
    return (
      <>
      <div className="search-form-bkg" onClick={() => this.props.showMissions()}></div>
        <div className="search-form">
          <h1>Missioni</h1>
          <ul className="ul-missions">
            {
              this.prepareMissions().map((m, index) => {
                return (
                  <li key={index}>
                    <a href={URIS.mission + this.parseHoles(m)} alt={'Missione ' + (index + 1)} target="_blank" className="lnk-go2mission" rel="noopener noreferrer">
                      Missione {index + 1}
                      <span>({m.length} anomalie) <i className="fas fa-chevron-right"></i></span>
                    </a>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </>
    )
  }
}

export default MissionChoicer
